module.exports = __webpack_public_path__ + "60d659d0da46d845395295c7ff60bbec.svg";